<template>
  <div :style="{ width: `${width}`, height: `${height}` }" class="cube-fr-report-iframe">
    <div v-loading="loading" class="cube-fr-report-iframe-inner">
      <el-result v-if="clickCancel" icon="info" title="提示" sub-title="请登录加载报表。">
        <template slot="extra">
          <el-button type="primary" size="mini" @click="reload">登录</el-button>
        </template>
      </el-result>
    </div>
    <login-dialog :visible.sync="loginVisible" @cancel="onCancel" @login="login" />
  </div>
</template>
<script>
import loginDialog from '../../common/login.vue'
import utils from '../../common/utils.js'
import { request } from '@cndinfo/cube-web-utils'
import '../../../../../lib/styles/components/FinePrint.scss'
export default {
  name: 'FrReport',
  components: {
    loginDialog
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    requireAccess: {
      type: Boolean,
      default: false
    },
    autoInit: {
      type: Boolean,
      default: true
    },
    height: {
      type: String,
      default: '100%'
    },
    width: {
      type: String,
      default: '100%'
    },
    loginPath: {
      type: String,
      default: '/webroot/decision/login/cross/domain'
    },
    origin: {
      type: String,
      default: ''
    },
    iframeId: {
      type: String,
      default: 'report-iframe'
    }
  },
  data() {
    return {
      loginVisible: false,
      hasLoadedReport: false,
      loading: false,
      clickCancel: false,
      username: '',
      password: '',
      msg: null,
      iframeEl: null,
      sysConfig: {}
    }
  },
  computed: {
    origin_() {
      const sysOrigin = this.sysConfig['sys.print.access.address']
      return this.origin || sysOrigin
    }
  },
  mounted() {
    if (!this.origin_) {
      request({
        url: 'system/sysParamInfo/detail/param.config',
        method: 'POST',
        noLoading: true
      }).then(res => {
        this.$set(this, 'sysConfig', res.data)
      })
    }

    const messageEvent = (event) => {
      const { code, id } = event.data
      if (id === this.iframeId) {
        const node = document.querySelector('#' + this.iframeId)
        if (code && code === 200) {
          node.style.display = 'block'
          this.loginVisible && (this.loginVisible = false)
          this.loading = false
          this.clickCancel = false
          if (this.username && this.password) {
            utils.saveFineUser(
              this.username,
              this.password
            )
          }
          node.src = this.url
          node.style.display = 'block'
        } else if (code && code === 500) {
          if (this.msg) {
            this.$message.error('操作失败，请检查账户名及密码是否正确。')
            this.msg.close()
            this.msg = null
          } else {
            this.msg = this.$message({
              type: 'error',
              message: '操作失败，请检查账户名及密码是否正确。'
            })
          }
          utils.removeIframe(this.iframeId)
          utils.removeFineUser()
          this.loginVisible = true
          this.hasLoadedReport = false
          this.loading = false
          this.clickCancel = true
        }
      }
    }
    window.addEventListener('message', messageEvent, false)
    this.$once('hook:beforeDestroy', () => {
      utils.removeIframe(this.iframeId)
      window.removeEventListener('message', messageEvent, false)
    })
    if (this.autoInit) {
      this.init()
    } else {
      this.clickCancel = true
    }
  },
  methods: {
    reload() {
      this.init()
    },
    onCancel() {
      this.clickCancel = true
    },
    login(res) {
      this.clickCancel = false
      this.username = res.username
      this.password = res.password
      this.createIframeWithLogin(res)
      this.loginVisible = false
    },
    init() {
      this.clickCancel = false
      if (this.requireAccess) {
        if (!utils.checkFineUser()) {
          // 没有用户名和密码，应该提示登录
          this.loginVisible = true
        } else {
          // 查询到了，不需要登录
          const { username, password } = utils.getFineUser()
          let res = null
          if (username && password) {
            res = {
              username,
              password
            }
          } else {
            res = {
              username: this.username,
              password: this.password
            }
          }
          this.createIframeWithLogin(res)
        }
      } else {
        // 不需要登陆
        this.withoutAccess()
      }
    },
    withoutAccess() {
      this.loading = true
      const iframe = this.createIframe()
      this.$el.querySelector('.cube-fr-report-iframe-inner').appendChild(iframe)
      this.loading = false
    },
    createIframeWithLogin(res) {
      this.clickCancel = false
      const { username, password } = res
      const { loginPath } = this
      const enCodeUsername = encodeURIComponent(username)
      const enCodePassword = encodeURIComponent(password)
      const validity = `validity=-1`
      const loginUrl = `${this.origin_}${loginPath}?fine_username=${enCodeUsername}&fine_password=${enCodePassword}&${validity}` // 省略callback参数 &callback=callback
      const validateIframePath = `${this.origin_}/webroot/decision/view/report?op=write&viewlet=iframe.cpt`
      const cb = (scr) => {
        console.log(scr)
      }
      console.log(loginUrl, validateIframePath)
      this.iframeEl = this.createIframe(loginUrl, validateIframePath, cb)
      if (this.requireAccess) {
        this.iframeEl.style.display = 'none'
      }
      this.$el.querySelector('.cube-fr-report-iframe-inner').appendChild(this.iframeEl)
    },
    createIframe(url, validateIframePath, onLoadCallback) {
      this.loading = true
      this.clickCancel = false
      const scr = document.createElement('iframe') // 创建iframe
      scr.id = this.iframeId
      scr.width = '100%'
      scr.height = '100%'
      scr.src = url || this.url
      if (this.requireAccess) {
        scr.onload = () => {
          if (!this.hasLoadedReport) { // 如果报表尚未加载
            scr.src = validateIframePath
            this.hasLoadedReport = true // 将标志变量设为true，表示报表已加载
            setTimeout(() => {
              const config = {
                data: {
                  reportlets: []
                }
              }
              const methods = 'console.log()'
              utils.sendMessageToIframe(JSON.stringify(config) + '---' + methods + '---' + this.iframeId, this.iframeId, this.origin_)
              onLoadCallback && onLoadCallback(scr)
            }, 3000)
          }
        }
      }
      return scr
    }
  }

}
</script>

